export default __webpack_public_path__ + "/src/assets/images/ecosystem_green_notext.svg";